export function formatCurrency(value) {
  const abs = Math.abs(value);
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(abs);
}

// formatCurrency drops the sign because most callers add their own parentheses.
// Effective Capital can legitimately be negative, so it needs them added here.
export function formatSignedCurrency(value) {
  const n = Number(value) || 0;
  return n < 0 ? `(${formatCurrency(n)})` : formatCurrency(n);
}

export function formatCurrencyFull(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    currencySign: 'accounting',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatDelta(value) {
  if (value === 0) return '—';
  const abs = Math.abs(value);
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(abs);
  return value < 0 ? `(${formatted})` : `+${formatted}`;
}

export function valueClass(value) {
  if (value < 0) return 'value-negative';
  if (value > 0) return 'value-positive';
  return '';
}

export function deltaClass(value) {
  if (value < 0) return 'value-negative';
  if (value > 0) return 'value-positive';
  return 'text-gray-500';
}

// Plaid/bank sync times are shown in Pacific, unlike the Denver reporting days.
export const SYNC_TIME_ZONE = 'America/Los_Angeles';

export function formatTimestamp(date) {
  if (!date) return '—';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleTimeString('en-US', {
    timeZone: SYNC_TIME_ZONE,
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
}

// "09/04/26 @ 3:40 PM PT"
export function formatSyncTimestamp(date) {
  if (!date) return '—';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return '—';
  const datePart = d.toLocaleDateString('en-US', {
    timeZone: SYNC_TIME_ZONE,
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
  });
  const timePart = d.toLocaleTimeString('en-US', {
    timeZone: SYNC_TIME_ZONE,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  return `${datePart} @ ${timePart} PT`;
}

export function formatDateLong(date) {
  if (!date) return '—';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('en-US', {
    timeZone: REPORTING_TIME_ZONE,
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatDateShort(date) {
  if (!date) return '—';
  const d = typeof date === 'string' ? new Date(`${date}T12:00:00`) : date;
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

// Effective Capital days are Denver calendar days on the server, so the report
// has to ask for them in that zone: a browser in UTC rolls over hours early and
// would request a date the server considers the future.
export const REPORTING_TIME_ZONE = 'America/Denver';

function reportingISO(d) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: REPORTING_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);
}

export function todayISO() {
  return reportingISO(new Date());
}

export function yesterdayISO() {
  const d = new Date(`${todayISO()}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
}

export function entityLabel(entity) {
  return entity === 'kings_loot' ? 'Kings Loot' : 'Kings Holding';
}
